import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoaderUiComponent } from '../loader/loader.ui-component';
import { BackLinkUiComponent } from '../back-link/back-link.ui-component';

@Component({
  selector: 'mt-layout',
  standalone: true,
  imports: [CommonModule, LoaderUiComponent, BackLinkUiComponent],
  templateUrl: './layout.ui-component.html',
  styleUrl: './layout.ui-component.scss',
})
export class LayoutUiComponent {
  @Input() title = '';
  @Input() isLoading = false;

  @Input() previousPageUrl = '';
}
